import {DEFAULT_LOCALE} from '../src/constants';
import {Locale} from '../src/RootProvider/LocaleContext';
import {ObjectOfStrings} from '../src/types';
import en from './translations/en.json';
import nl from './translations/nl-NL.json';

interface i18nData {
  en: ObjectOfStrings;
  nl: ObjectOfStrings;
}

const i18n = {
  en,
  nl,
} as unknown as i18nData;

const getMessages = (locale: string = DEFAULT_LOCALE): ObjectOfStrings => {
  // test hatch - use blank translations so key is displayed
  if (locale === Locale.test) {
    return {};
  }

  let lang: keyof i18nData = 'en';

  // nl overloads
  if (locale === Locale.nl || locale === 'nl-NL') {
    lang = 'nl';
  }

  // language and missing translations from selected locale fallback to english
  return {
    ...i18n.en,
    ...i18n[lang],
  };
};

export default getMessages;
